import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=6031a3ad&scoped=true"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031a3ad",
  null
  
)

export default component.exports